import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PromisesService {
    private promises: { [key: string]: Promise<any> } = {};
    private sequentialActions: { [key: string]: Set<any> } = {};

    private clear(key: string, duration?: number): void {
        duration = duration || 0;

        setTimeout(() => {
            delete this.promises[key];
        }, duration * 1000);
    }

    public async share<T>(key: string, action: any, duration?: number): Promise<T> {
        if (!!this.promises[key]) {
            return this.promises[key];
        }

        const promise = action();
        this.promises[key] = promise;

        try {
            const result = await promise;
            this.clear(key, duration);
            return result;
        } catch (err) {
            this.clear(key, 0);
            throw err;
        }
    }

    public get<T>(key: string): Promise<T> {
        return this.promises[key];
    }

    public async put<T>(key: string, action: any, timeout: number = 0): Promise<T> {
        if (!this.sequentialActions[key]) {
            this.sequentialActions[key] = new Set<Promise<any>>();
        }
        this.sequentialActions[key].add(action);

        return await this.share(key,
            async () => {
                return await new Promise((resolve, reject) => {
                    setTimeout(async () => {
                        try {
                            for (const action of this.sequentialActions[key]) {
                                this.sequentialActions[key].delete(action);
                                const result = await action();
                                if (this.sequentialActions[key].size === 0) {
                                    resolve(result);
                                    return;
                                }
                            }
                            resolve(null);
                        } catch (err) {
                            reject(err);
                        }
                    }, timeout);
                })
            },
            (timeout - 0.05 * timeout) / 1000);
    }

    public clearAll() {
        this.promises = {};
    }
}
